import { createContext } from 'react';
import FormLayout from '../../../../../@Api/Layout/Type/Form/FormLayout';

export default createContext<FormLayout>(undefined);
